import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/api";
import PostsList from "./PostList";
import AkkhorLayout from "../layout/akkhor";
import { useParams } from "react-router-dom";
import Calendar from "./Calendar";
import { checkRole } from "../model";


export default function BangTin() {
  const { user } = useSelector((state) => state.auth);
  const { alias } = useParams();
  const info = user && user.data ? user.data : null;
  const [listnews, setListNews] = useState(null)
  const roleBaoCao = checkRole(user, 'blue-counting', '')
  const [baocaoblue, setBaocaoblue] = useState([])

  useEffect(() => {    
    axios.get(URL_LIST_ALL + "news?limit=10000&forusers=" + user.data.code, user.config)
      .then(async (res) => {
        if (res.data.status === "success") {
          setListNews(res.data.data)
        } else console.log(res.data.message);
      })
      .catch((err) => console.log(err));
  }, [user]);// eslint-disable-line

  useEffect(() => {
    axios.get(URL_LIST_ALL + "baocaoblue?limit=10", user.config)
      .then(async (res) => {
        if (res.data.status === "success") {
          setBaocaoblue(res.data.data)
        } else console.log(res.data.message);
      })
      .catch((err) => console.log(err));
  }, [user]);// eslint-disable-line

  return (
    <AkkhorLayout idrole="dashboard" class_name="home-dashboard-content">
      <div className="row home-dashboad">
        {info &&
          <div className="container-fluid pb-0 form-info">
            <div className="row">
              <div className="col-12 col-md-8 list-post-content">
                <PostsList pagealias={alias} />
              </div>
              <div className="col-12 col-md-4 pl-0 d-none d-sm-block right-sidebar">
                <div className="w-100 baocaoblue">
                  <h5 className="text-center">Top tương tác tháng</h5>
                  <div className="w-100 d-flex justify-content-center mt-2">
                    <div className="calendar-container">
                      <table className="table table-striped table-bordered table-hover font-13">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Họ tên</th>
                            <th>Like</th>
                            <th>Comment</th>
                            <th>Tương tác</th>
                          </tr>
                        </thead>
                        <tbody>
                          {baocaoblue && baocaoblue.map((item, i) => {
                            return <tr key={item.id}>
                              <td className="text-center">{i + 1}</td>
                              <td>{item.fullname}</td>
                              <td className="text-center">{item.total_likes}</td>
                              <td className="text-center">{item.total_comments}</td>
                              <td className="text-center">{item.total_interactions}</td>
                            </tr>
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="w-100 d-flex justify-content-center">
                  <Calendar />
                </div>
                <div className="w-100 d-flex justify-content-center">
                  <div className=" bg-white-border pd-15">
                    <h5 className="w-100 text-center">Quy trình nội bộ</h5>
                    <ul className="dashboard-list-new">
                      {listnews && listnews.map((item, i) => {
                        return (
                          <li key={i}>
                            <a href={"/quy-trinh-noi-bo/" + item.id}><i className="	fas fa-angle-double-right"></i> {item.title}</a>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </AkkhorLayout>)
}